import { render, staticRenderFns } from "./dealer-roof.vue?vue&type=template&id=60f88fe8"
import script from "./dealer-roof.vue?vue&type=script&lang=js"
export * from "./dealer-roof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports